"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overline = exports.Caption = exports.Button = exports.Subtitle2 = exports.Subtitle1 = exports.Body2 = exports.Body1 = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
exports.H1 = react_1.forwardRef(function H1(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h1" }, props, { ref: ref }), void 0);
});
exports.H2 = react_1.forwardRef(function H2(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h2" }, props, { ref: ref }), void 0);
});
exports.H3 = react_1.forwardRef(function H3(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h3" }, props, { ref: ref }), void 0);
});
exports.H4 = react_1.forwardRef(function H4(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h4" }, props, { ref: ref }), void 0);
});
exports.H5 = react_1.forwardRef(function H5(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h5" }, props, { ref: ref }), void 0);
});
exports.H6 = react_1.forwardRef(function H6(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "h6" }, props, { ref: ref }), void 0);
});
exports.Body1 = react_1.forwardRef(function Body1(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "body1" }, props, { ref: ref }), void 0);
});
exports.Body2 = react_1.forwardRef(function Body2(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "body1" }, props, { ref: ref }), void 0);
});
exports.Subtitle1 = react_1.forwardRef(function Subtitle1(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "subtitle1" }, props, { ref: ref }), void 0);
});
exports.Subtitle2 = react_1.forwardRef(function Subtitle2(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "subtitle2" }, props, { ref: ref }), void 0);
});
exports.Button = react_1.forwardRef(function Button(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "button" }, props, { ref: ref }), void 0);
});
exports.Caption = react_1.forwardRef(function Caption(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "caption" }, props, { ref: ref }), void 0);
});
exports.Overline = react_1.forwardRef(function Overline(props, ref) {
    return jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "overline" }, props, { ref: ref }), void 0);
});
//# sourceMappingURL=Typography.js.map